import type React from 'react';

import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { SYSTEM_ROUTS } from '@/routes/SystemRoutes.enum.ts';
import { LocalStorageParam, setLocalStorage } from '@/utils/localStorage.util.ts';

/**
 * Persists the last visited location so the user can be redirected back to it
 * after signing in (see LoginSuccessfulView). System routes are excluded,
 * they are never a meaningful place to return to.
 */
export const LastVisitedLocationController: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!SYSTEM_ROUTS.includes(pathname)) {
      setLocalStorage(LocalStorageParam.LAST_VISITED_LOCATION, pathname);
    }
  }, [pathname]);

  return null;
};
